import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

import CopyButtonExpandedContent from "./CopyButtonExpandedContent";

export default function CopyButton({
  selected,
  onClick,
  dataCy,
  onSave,
  onCancel,
  title,
  text,
  iconClass,
  showTitleInput = true,
  titleInputLabel,
  availableGroups = [],
  defaultGroupID,
  saving,
  shouldShowButton,
  selectedAction,
  delay,
  showShareCheckbox,
  errors,
  setErrors,
}) {
  const animations = {};
  //     initial: { height: 0 },
  //     animate: { height: "100%" },
  //     exit: { height: 0 },
  //     transition: { duration: 0.25, delay: 2.5 },
  //   };

  const animationStyles = {
    height: shouldShowButton ? "inherit" : 0,
    // marginTop: shouldShowButton ? 12 : 0,
  };

  return (
    <>
      {/* <Spacer animate={{ height: selectedAction ? 0 : 12 }} /> */}
      <Wrapper
        onClick={onClick}
        data-cy={dataCy}
        selected={selected}
        $showing={shouldShowButton}
        animate={animationStyles}
        transition={{ delay: delay }}
      >
        <Inside whileTap={!selected ? { scale: 0.96 } : null}>
          <Icon className={iconClass} />
          <Content>
            <Title data-cy="title">{title}</Title>
            <Text data-cy="description">{text}</Text>
          </Content>
        </Inside>
        <AnimatePresence>
          {selected && (
            <CopyButtonExpandedContent
              showTitleInput={showTitleInput}
              availableGroups={availableGroups}
              defaultGroupID={defaultGroupID}
              onSave={onSave}
              onCancel={onCancel}
              saving={saving}
              titleInputLabel={titleInputLabel}
              selectedAction={selectedAction}
              showShareCheckbox={showShareCheckbox}
              errors={errors}
              setErrors={setErrors}
            />
          )}
        </AnimatePresence>
      </Wrapper>
    </>
  );
}

// &:hover {
//     ${(props) =>
//       !props.selected &&
//       `border: 1px solid rgba(255, 255, 255, 0.6);
//     background: rgba(255, 255, 255, 0.1);`}
//   }
// ${(props) => !props.selected && "cursor: pointer;"}

// ${({ showing }) => !showing && `border: none; margin-top: 0;`}

const Spacer = styled(motion.div)``;

const Wrapper = styled(motion.div)`
  border: 1px solid rgba(255, 255, 255, 0.2);
  ${({ $showing }) => !$showing && `border: none;`}
  // margin-top: 12px;
  border-radius: 8px;
  transition: 0.2s;

  background: rgba(255, 255, 255, 0.05);
  overflow: hidden;

  &:hover {
    ${(props) =>
      !props.selected &&
      `border: 1px solid rgba(255, 255, 255, 0.6);
      background: rgba(255, 255, 255, 0.1);`}
  }
  ${(props) => !props.selected && "cursor: pointer;"}
`;
const Inside = styled(motion.div)`
  display: flex;
  align-items: center;
  padding: 12px;
`;
const Icon = styled.div`
  font-size: 32px;
  width: 32px;
  text-align: center;
  margin-right: 12px;
  flex-shrink: 0;
`;
const Content = styled.div`
  flex-grow: 1;
`;
const Title = styled.div`
  font-size: 20px;
  font-weight: 400;
`;
const Text = styled.div`
  font-size: 14px;
`;
